import axios from 'axios';

const http = axios.create({ baseURL: '/api', timeout: 90000 });

// 携带登录态
http.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// 401/403 统一抛带 code 的错误（页面据此提示登录/续费）
http.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err.response && err.response.data;
    err.code = (d && d.code) || err.response && err.response.status;
    err.msg = (d && d.error) || err.message;
    return Promise.reject(err);
  },
);

export default http;
